<mat-card-content>
  <mat-card-header class="contenedor_header_informacion">
    <mat-card-title class="m-b-0"><h5>Socios</h5></mat-card-title>
    <div class="container__button">
      <!-- <button mat-raised-button color="primary" (click)="getDicomPartners()" *ngIf="existenSocios == true && hasDicomPermission">
          Consulta DICOM
        </button> -->
      <button
        class="d-flex align-items-center m-y-32"
        type="button"
        mat-stroked-button
        color="primary"
        (click)="addNew('partner')"
      >
        Agregar Socio
      </button>
    </div>
  </mat-card-header>
  <ng-template #SinSocios>
    <div>
      <h3 style="text-align: center">No se encontraron Socios</h3>
    </div>
  </ng-template>
  <div
    *ngIf="this.dataSourceOwners?.data.length >= 1; else SinSocios"
    class="table-responsive"
  >
    <table mat-table [dataSource]="dataSourceOwners" class="mat-elevation-z8">
      <ng-container matColumnDef="fullRut">
        <th mat-header-cell *matHeaderCellDef class="th-title">RUT</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fullRut }}
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="th-title">Nombre</th>
        <td mat-cell *matCellDef="let element">
          {{ element.completeName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="participation">
        <th mat-header-cell *matHeaderCellDef class="th-title">
          Participacion
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.participation + "%" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="civilState">
        <th mat-header-cell *matHeaderCellDef class="th-title">Estado Civil</th>
        <td mat-cell *matCellDef="let element">
          {{ element.civilState ? element.civilState : "-" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="age">
        <th mat-header-cell *matHeaderCellDef class="th-title">Edad</th>
        <td mat-cell *matCellDef="let element">
          {{ element.age ? element.age : "-" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="isAval">
        <th mat-header-cell *matHeaderCellDef class="th-title">AVAL</th>
        <td mat-cell *matCellDef="let element">
          <i-tabler
            *ngIf="element.isAval == true"
            name="circle-check-filled"
            class="icon-20"
            style="color: mediumspringgreen"
          ></i-tabler>
          <i-tabler
            *ngIf="element.isAval == false || element.isAval == null"
            name="circle-filled"
            class="icon-20"
            style="color: rgb(250, 0, 0)"
          ></i-tabler>
        </td>
      </ng-container>
      <ng-container matColumnDef="isRL">
        <th mat-header-cell *matHeaderCellDef class="th-title">RL</th>
        <td mat-cell *matCellDef="let element">
          <i-tabler
            *ngIf="element.isRL == true"
            name="circle-check-filled"
            class="icon-20"
            style="color: mediumspringgreen"
          ></i-tabler>
          <i-tabler
            *ngIf="element.isRL == false || element.isRL == null"
            name="circle-filled"
            class="icon-20"
            style="color: rgb(250, 0, 0)"
          ></i-tabler>
        </td>
      </ng-container>
      <ng-container matColumnDef="deudaDicom" style="cursor: pointer">
        <th mat-header-cell *matHeaderCellDef class="th-title">Dicom</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          <div *ngIf="!booleanFlag">
            {{ element.deudaDicom | millionsFormat }}
          </div>
          <div
            *ngIf="booleanFlag"
            style="display: flex; justify-content: center"
          >
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="deudaSbif" style="cursor: pointer">
        <th mat-header-cell *matHeaderCellDef class="th-title">Sbif</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          <div *ngIf="!booleanFlag && element.deudaSbif != null">
            {{ element.deudaSbif | number }}
          </div>
          <div *ngIf="!booleanFlag && element.deudaSbif == null">S/Info</div>
          <div
            *ngIf="booleanFlag"
            style="display: flex; justify-content: center"
          >
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="eliminar">
        <th mat-header-cell *matHeaderCellDef class="th-title">Eliminar</th>
        <td mat-cell *matCellDef="let element">
          <i-tabler name="trash" class="icon-20 trash"
            (click)="deleteOwners(element.companyLegalOwnerId, element.name)"></i-tabler>
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumnsOwners"></tr>

      <tr
        mat-row
        [cdkContextMenuTriggerFor]="menu"
        (dblclick)="openUrl(row.companyId)"
        *matRowDef="let row; columns: displayedColumnsOwners"
        class="cursor_table"
      >
        <ng-template #menu>
          <div
            cdkMenu
            class="context_menu mat-elevation-z0"
            style="z-index: 999"
          >
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="updateInfo(row, 'partner')"
              >
                Editar
              </button>
            </li>
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="formDicom(row.fullRut)"
              >
                Equifax
              </button>
            </li>
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="formSbif(row)"
              >
                Sbif
              </button>
            </li>
            <li>
              <button
                class="context-menu-item trash"
                cdkMenuItem
                mat-raised-button
                (click)="
                  deleteOwners(row.relationId, row.completeName, 'socio')
                "
                style="
                  background-color: rgb(250, 0, 0);
                  color: white;
                  font-weight: 600;
                "
              >
                Eliminar
              </button>
            </li>
          </div>
        </ng-template>
      </tr>
    </table>
  </div>
</mat-card-content>

<mat-card-content>
  <mat-card-header class="contenedor_header_informacion">
    <mat-card-title class="m-b-0"><h5>Representantes</h5></mat-card-title>
    <div class="container__button">
      <button
        class="d-flex align-items-center m-y-32"
        type="button"
        mat-stroked-button
        color="primary"
        (click)="addNew('representative')"
      >
        Agregar Representante
      </button>
    </div>
  </mat-card-header>
  <ng-template #SinRepresentantes>
    <div>
      <h3 style="text-align: center">No se encontraron representantes</h3>
    </div>
  </ng-template>
  <div
    *ngIf="
      this.dataSourceRepresentatives?.data.length >= 1;
      else SinRepresentantes
    "
    class="table-responsive"
  >
    <table
      mat-table
      [dataSource]="dataSourceRepresentatives"
      class="mat-elevation-z8"
    >
      <ng-container matColumnDef="fullRut">
        <th mat-header-cell *matHeaderCellDef class="th-title">RUT</th>
        <td mat-cell *matCellDef="let element; let i = index">
          <span *ngIf="mostrarColumna[i]">
            {{ element.fullRut }}
          </span>
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="th-title">Nombre</th>
        <td mat-cell *matCellDef="let element">
          {{ element.completeName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="role">
        <th mat-header-cell *matHeaderCellDef class="th-title">Rol</th>
        <td mat-cell *matCellDef="let element">
          {{ element.role }}
        </td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef class="th-title">Email</th>
        <td mat-cell *matCellDef="let element">
          {{ element.email }}
        </td>
      </ng-container>
      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef class="th-title">Teléfono</th>
        <td mat-cell *matCellDef="let element">
          {{ element.phone }}
        </td>
      </ng-container>
      <ng-container matColumnDef="deudaDicom" style="cursor: pointer">
        <th mat-header-cell *matHeaderCellDef class="th-title">Dicom</th>
        <td mat-cell *matCellDef="let element  let i = index" style="cursor: pointer">
          <div *ngIf="!booleanFlag && mostrarColumna[i]">
            {{ element.deudaDicom | millionsFormat }}
          </div>
          <span *ngIf="!mostrarColumna[i]">
            n/a
          </span>
          <div
            *ngIf="booleanFlag"
            style="display: flex; justify-content: center"
          >
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="deudaSbif" style="cursor: pointer">
        <th mat-header-cell *matHeaderCellDef class="th-title">Sbif</th>
        <td mat-cell *matCellDef="let element; let i = index" style="cursor: pointer">
          <div *ngIf="!booleanFlag && element.deudaSbif != null">
            {{ element.deudaSbif | number }}
          </div>
          <div *ngIf="!booleanFlag && element.deudaSbif == null && mostrarColumna[i] ">S/Info</div>
          <span *ngIf="!mostrarColumna[i]">
            n/a
          </span>
          <div
            *ngIf="booleanFlag"
            style="display: flex; justify-content: center"
          >
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="eliminar">
        <th mat-header-cell *matHeaderCellDef class="th-title">Eliminar</th>
        <td mat-cell *matCellDef="let element">
          <i-tabler name="trash" class="icon-20 trash"
            (click)="deleteOwners(element.companyLegalOwnerId, element.name)"></i-tabler>
        </td>
      </ng-container> -->

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumnsRepresentatives"
      ></tr>

      <tr
        mat-row
        [cdkContextMenuTriggerFor]="menu"
        (dblclick)="openUrl(row.companyId)"
        *matRowDef="let row; columns: displayedColumnsRepresentatives; let i = index"
        class="cursor_table"
      >
        <ng-template #menu>
          <div
            cdkMenu
            class="context_menu mat-elevation-z0"
            style="z-index: 999"
          >
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="updateInfo(row, 'representative')"
              >
                Editar
              </button>
            </li>
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="formDicom(row.fullRut)"
                *ngIf="mostrarColumna[i]"
              >
                Equifax
              </button>
            </li>
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="formSbif(row)"
                *ngIf="mostrarColumna[i]"
              >
                Sbif
              </button>
            </li>
            <li>
              <button
                class="context-menu-item trash"
                cdkMenuItem
                mat-raised-button
                (click)="
                  deleteOwners(
                    row.relationId,
                    row.completeName,
                    'representante'
                  )
                "
                style="
                  background-color: rgb(250, 0, 0);
                  color: white;
                  font-weight: 600;
                "
              >
                Eliminar
              </button>
            </li>
          </div>
        </ng-template>
      </tr>
    </table>
  </div>
</mat-card-content>

<mat-card-content>
  <mat-card-header class="contenedor_header_informacion">
    <mat-card-title class="m-b-0"><h5>Sociedades</h5></mat-card-title>
    <div class="container__button">
      <button
        class="d-flex align-items-center m-y-32"
        type="button"
        mat-stroked-button
        color="primary"
        (click)="addNew('sociedades')"
      >
        Agregar Sociedad
      </button>
    </div>
  </mat-card-header>
  <ng-template #SinSociedades>
    <div>
      <h3 style="text-align: center">No se encontraron sociedades</h3>
    </div>
  </ng-template>
  <div
    *ngIf="this.dataSourceSocieties?.data.length >= 1; else SinSociedades"
    class="table-responsive"
  >
    <table
      mat-table
      [dataSource]="dataSourceSocieties"
      class="mat-elevation-z8"
    >
      <ng-container matColumnDef="fullRut">
        <th mat-header-cell *matHeaderCellDef class="th-title">RUT</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fullRut }}
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="th-title">Nombre</th>
        <td mat-cell *matCellDef="let element">
          {{ element.completeName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="deudaDicom" style="cursor: pointer">
        <th mat-header-cell *matHeaderCellDef class="th-title">Dicom</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          <div *ngIf="!booleanFlag">
            {{ element.deudaDicom | millionsFormat }}
          </div>
          <div
            *ngIf="booleanFlag"
            style="display: flex; justify-content: center"
          >
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="deudaSbif" style="cursor: pointer">
        <th mat-header-cell *matHeaderCellDef class="th-title">Sbif</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          <div *ngIf="!booleanFlag && element.deudaSbif != null">
            {{ element.deudaSbif | number }}
          </div>
          <div *ngIf="!booleanFlag && element.deudaSbif == null">S/Info</div>
          <div
            *ngIf="booleanFlag"
            style="display: flex; justify-content: center"
          >
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="eliminar">
        <th mat-header-cell *matHeaderCellDef class="th-title">Eliminar</th>
        <td mat-cell *matCellDef="let element">
          <i-tabler name="trash" class="icon-20 trash"
            (click)="deleteOwners(element.companyLegalOwnerId, element.name)"></i-tabler>
        </td>
      </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="displayedColumnsSocieties"></tr>
      <tr
        mat-row
        [cdkContextMenuTriggerFor]="menu"
        *matRowDef="let row; columns: displayedColumnsSocieties"
        class="cursor_table"
        [ngClass]="{ RelationRow: true }"
        (dblclick)="openUrl(row.companyId)"
      >
        <ng-template #menu>
          <div
            cdkMenu
            class="context_menu mat-elevation-z0"
            style="z-index: 999"
          >
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="formDicom(row.fullRut)"
              >
                Equifax
              </button>
            </li>
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="formSbif(row)"
              >
                Sbif
              </button>
            </li>
            <li>
              <button
                class="context-menu-item trash"
                cdkMenuItem
                mat-raised-button
                (click)="
                  deleteOwners(row.relationId, row.completeName, 'sociedad')
                "
                style="
                  background-color: rgb(250, 0, 0);
                  color: white;
                  font-weight: 600;
                "
              >
                Eliminar
              </button>
            </li>
          </div>
        </ng-template>
      </tr>
    </table>
  </div>
</mat-card-content>

<mat-card-content>
  <mat-card-header class="contenedor_header_informacion">
    <mat-card-title class="m-b-0"
      ><h5>Otras empresas relacionadas</h5></mat-card-title
    >
    <div class="container__button">
      <button
        class="d-flex align-items-center m-y-32"
        type="button"
        mat-stroked-button
        color="primary"
        (click)="addNew('otros')"
      >
        Agregar empresa relacionada
      </button>
    </div>
  </mat-card-header>
  <ng-template #SinEmpresasRelacionadas>
    <div>
      <h3 style="text-align: center">No existen empresas relacionadas</h3>
    </div>
  </ng-template>
  <div
    *ngIf="
      this.dataSourceOthers?.data.length >= 1;
      else SinEmpresasRelacionadas
    "
    class="table-responsive"
  >
    <table mat-table [dataSource]="dataSourceOthers" class="mat-elevation-z8">
      <ng-container matColumnDef="fullRut">
        <th mat-header-cell *matHeaderCellDef class="th-title">RUT</th>
        <td mat-cell *matCellDef="let element">
          {{ element.fullRut }}
        </td>
      </ng-container>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef class="th-title">Nombre</th>
        <td mat-cell *matCellDef="let element">
          {{ element.completeName }}
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef class="th-title">Descripción</th>
        <td mat-cell *matCellDef="let element">
          {{ element.description }}
        </td>
      </ng-container>
      <ng-container matColumnDef="deudaDicom" style="cursor: pointer">
        <th mat-header-cell *matHeaderCellDef class="th-title">Dicom</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          <div *ngIf="!booleanFlag">
            {{ element.deudaDicom | millionsFormat }}
          </div>
          <div
            *ngIf="booleanFlag"
            style="display: flex; justify-content: center"
          >
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        </td>
      </ng-container>
      <ng-container matColumnDef="deudaSbif" style="cursor: pointer">
        <th mat-header-cell *matHeaderCellDef class="th-title">Sbif</th>
        <td mat-cell *matCellDef="let element" style="cursor: pointer">
          <div *ngIf="!booleanFlag && element.deudaSbif != null">
            {{ element.deudaSbif | number }}
          </div>
          <div *ngIf="!booleanFlag && element.deudaSbif == null">S/Info</div>
          <div
            *ngIf="booleanFlag"
            style="display: flex; justify-content: center"
          >
            <mat-spinner diameter="20"></mat-spinner>
          </div>
        </td>
      </ng-container>
      <!-- <ng-container matColumnDef="eliminar">
        <th mat-header-cell *matHeaderCellDef class="th-title">Eliminar</th>
        <td mat-cell *matCellDef="let element">
          <i-tabler name="trash" class="icon-20 trash"
            (click)="deleteOwners(element.companyLegalOwnerId, element.name)"></i-tabler>
        </td>
      </ng-container> -->

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumnsOthers"
        [ngClass]="{ RelationRow: true }"
      ></tr>

      <tr
        mat-row
        [cdkContextMenuTriggerFor]="menu"
        (dblclick)="openUrl(row.companyId)"
        *matRowDef="let row; columns: displayedColumnsOthers"
        class="cursor_table"
      >
        <ng-template #menu>
          <div
            cdkMenu
            class="context_menu mat-elevation-z0"
            style="z-index: 999"
          >
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="updateInfo(row, 'otros')"
              >
                Editar
              </button>
            </li>
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="formDicom(row.fullRut)"
              >
                Equifax
              </button>
            </li>
            <li>
              <button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                (click)="formSbif(row)"
              >
                Sbif
              </button>
            </li>
            <li>
              <button
                class="context-menu-item trash"
                cdkMenuItem
                mat-raised-button
                (click)="
                  deleteOwners(row.relationId, row.completeName, 'otros')
                "
                style="
                  background-color: rgb(250, 0, 0);
                  color: white;
                  font-weight: 600;
                "
              >
                Eliminar
              </button>
            </li>
          </div>
        </ng-template>
      </tr>
    </table>
  </div>
</mat-card-content>
